import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import WorkflowListShell from '../components/workflow/WorkflowListShell';
import NowName from '../components/shared/NowName';
import WorkflowStatusBadge from '../components/workflow/WorkflowStatusBadge';
import { formatDateShort } from '../utils/dateFormat';

// Training absence declarations — list page
// (docs/modules/workflow-ld-absence.md). Self-service: every logged-in user
// sees their own declarations; holders of ld:absence:review see all of them
// and act from the detail page.
const WorkflowAbsence = () => {
  const { hasPermission } = useAuth();
  const canReview = hasPermission('ld:absence:review');
  return (
    <WorkflowListShell
      title="Training Absence"
      subtitle={canReview
        ? 'Absence declarations to review.'
        : 'Your absence declarations.'}
      newTo="/workflow/absence/new"
      newLabel="New Declaration"
      canCreate
      apiPath="/api/ld/absence-requests"
      searchPlaceholder="Search declaration / session / staff…"
      rowTo={(r) => `/workflow/absence/${r.id}`}
      columns={[
        {
          key: 'requestNo',
          label: 'Declaration',
          sortKey: 'requestNo',
          className: 'whitespace-nowrap',
          render: (r) => (
            <Link
              to={`/workflow/absence/${r.id}`}
              onClick={(e) => e.stopPropagation()}
              className="text-blue-600 hover:text-blue-800 font-medium"
            >
              {r.requestNo}
            </Link>
          ),
        },
        { key: 'staff', label: 'Staff', sortKey: 'staff', className: 'text-slate-700 whitespace-nowrap', render: (r) => <NowName value={r.staffName} now={r.staffNameNow} /> },
        { key: 'session', label: 'Session', sortKey: 'session', className: 'text-slate-900 max-w-xs truncate', cellTitle: (r) => r.sessionTitle, render: (r) => r.sessionTitle },
        { key: 'sessionDate', label: 'Session Date', sortKey: 'sessionDate', className: 'text-slate-700 whitespace-nowrap', render: (r) => (r.sessionDate ? formatDateShort(r.sessionDate) : '—') },
        { key: 'reason', label: 'Reason', sortKey: 'reason', className: 'text-slate-700 max-w-xs truncate', cellTitle: (r) => r.reasonDetail || r.reasonCategory, render: (r) => r.reasonCategory },
        { key: 'status', label: 'Status', sortKey: 'status', render: (r) => <WorkflowStatusBadge status={r.status} /> },
        { key: 'createdAt', label: 'Submitted', sortKey: 'createdAt', className: 'text-slate-600 whitespace-nowrap', render: (r) => formatDateShort(r.createdAt) },
      ]}
    />
  );
};

export default WorkflowAbsence;
